/* eslint import/no-mutable-exports: 0 */
/* eslint prefer-const: 0 */
import env from "../env";

let DEV_CONFIG = {
  API_URL: 'https://api.dev.lumenisx.lumenis.com.cn',
  GOOGLE_ANALYTICS_TRACKER_ID: '',
  QLIK_URL: 'https://qlik.lumenis.com/hub/stream/3cbd1f1b-a493-4739-9b4d-58b165cf7857',
  LOGIN_VIA_ADFS: env.REACT_APP_LOGIN_VIA_ADFS.toLowerCase() === "true",
  // SAML endpoints depend on the UMS version this env runs (UMS 5.19.1).
  // 5.19: /ums/adfs/saml/login + /ums/adfs/saml/logout?local=true; 5.20: /ums/saml2/authenticate/adfs, no SAML logout (null = local-only).
  SAML_LOGIN_PATH: '/ums/adfs/saml/login',
  SAML_LOGOUT_PATH: '/ums/adfs/saml/logout?local=true',
  EVENT_VIEWER_URL: 'https://eventViewer.dev.lumenisX.lumenis.com/setup',
  LOG_SUPPORT_VERSION: env.REACT_APP_MIN_LMX_VERSION_SUPPORT_LOGS,
  LOG_V2_SUPPORT_VERSION: env.REACT_APP_MIN_LMX_VERSION_SUPPORT_LOGS_V2,
  OTHER_REGION_URL: 'https://web.dev.lumenisx.lumenis.com/',
  OTHER_REGION_ICON_FILE_PATH: '/global_icon.png',
  HIDE_LICENSES: env.REACT_APP_HIDE_LICENSES.toLowerCase() === "true",
  LICENSE_NEARING_EXPIRATION_DAYS: env.REACT_APP_LICENSE_NEARING_EXPIRATION_DAYS
};

export default DEV_CONFIG;
